import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { a as TextLinkTypes } from './roche-text-link.types.js';
import { d as defineCustomElement$4 } from './roche-avatar2.js';
import { d as defineCustomElement$3 } from './roche-icon2.js';
import { d as defineCustomElement$2 } from './roche-text-link2.js';

var Layout;
(function (Layout) {
    Layout["VARIANT_A"] = "contact-person--variant-a";
    Layout["VARIANT_A_WITHOUT_IMAGE"] = "contact-person--variant-a-without-image";
    Layout["VARIANT_B"] = "contact-person--variant-b";
})(Layout || (Layout = {}));

const rocheContactPersonCss = ":host{display:block;margin-top:3rem;display:flex;flex-direction:column}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}roche-avatar,::slotted(roche-avatar){width:8rem;height:8rem}.name{padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:400;font-size:1.125rem;line-height:1.6875rem}.name strong{font-weight:600}@media (min-width: 48rem){.name{font-size:1.125rem;line-height:1.8125rem}}@media (min-width: 90rem){.name{font-size:1.25rem;line-height:1.875rem}}slot+.name{margin-top:2rem}.job-title{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--body-small--font-size--small-up);line-height:1.625rem}@media (min-width: 48rem){.job-title{font-size:var(--body-small--font-size--medium-up);line-height:1.8125rem}}.job-title,.email-address{margin-top:0.25rem}.phone-number{margin-top:0.5rem}";
const RocheContactPersonStyle0 = rocheContactPersonCss;

const RocheContactPerson$1 = /*@__PURE__*/ proxyCustomElement(class RocheContactPerson extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.layout = Layout.VARIANT_A;
        this.name = undefined;
        this.jobTitle = undefined;
        this.phoneNumber = undefined;
        this.emailAddress = undefined;
        this.type = TextLinkTypes.CONTACT_PERSON;
    }
    render() {
        const showAvatar = this.layout !== Layout.VARIANT_A_WITHOUT_IMAGE;
        const showContactInfo = this.layout !== Layout.VARIANT_B;
        return (h(Host, { key: '84005b5141b3b5a47de712c8ca347eba13c2f021' }, showAvatar && h("slot", { name: "avatar" }, h("roche-avatar", null)), h("div", { key: '10c4aad084f1dc669d7919aedc04492e31481f75', class: 'name' }, this.name), h("div", { key: '17f3650e624103aa7432b3b8618a04cf783a589e', class: 'job-title' }, this.jobTitle), showContactInfo && this.phoneNumber
            && h("roche-text-link", { type: this.type, class: 'phone-number', key: 'phone-number', href: `tel:${this.phoneNumber}`, text: this.phoneNumber, leftIcon: 'phone' }), showContactInfo && this.emailAddress
            && h("roche-text-link", { type: this.type, class: 'email-address', key: 'email-address', href: `mailto:${this.emailAddress}`, text: this.emailAddress, leftIcon: 'email' })));
    }
    static get style() { return RocheContactPersonStyle0; }
}, [1, "roche-contact-person", {
        "layout": [1],
        "name": [1],
        "jobTitle": [1, "job-title"],
        "phoneNumber": [1, "phone-number"],
        "emailAddress": [1, "email-address"],
        "type": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-contact-person", "roche-avatar", "roche-icon", "roche-text-link"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-contact-person":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheContactPerson$1);
            }
            break;
        case "roche-avatar":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-text-link":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheContactPerson = RocheContactPerson$1;
const defineCustomElement = defineCustomElement$1;

export { RocheContactPerson, defineCustomElement };

//# sourceMappingURL=roche-contact-person.js.map